import React, { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

const faqData = [
  {
    question: "What are the most popular gift cards in the UAE?",
    answer:
      "Popular gift cards can vary depending on the recipient and occasion. Shopping, gaming, entertainment, fashion and footwear gift cards are among the common categories shoppers look for in the UAE. Available brands and products can be explored on 99gift.ae.",
  },
  {
    question: "Where can I buy gift cards in the UAE?",
    answer:
      "You can browse and purchase available gift cards through 99gift.ae. The website offers gift cards across different categories and brands, with the available value and product details shown on the relevant product page.",
  },
  {
    question: "Can I buy gift cards online in the UAE?",
    answer:
      "Yes. You can browse available gift cards online, select a product and review its available value and purchase information before ordering.",
  },
  {
    question: "What is a digital gift card?",
    answer:
      "A digital gift card is an electronic gift voucher or card that can be delivered digitally and used according to the issuing brand's terms. The exact delivery and redemption method depends on the individual gift card.",
  },
  {
    question: "Which gift card is best in the UAE?",
    answer:
      "The best gift card depends on the recipient. Shopping gift cards can suit regular shoppers, gaming gift cards can be suitable for gamers, while fashion and entertainment gift cards can work well for people interested in those categories.",
  },
  {
    question: "Can I buy an Amazon gift card in the UAE?",
    answer:
      "If an Amazon gift card is available on 99gift.ae, you can view its available denominations, price and product information on the relevant Amazon gift card page before purchasing.",
  },
  {
    question: "Can I buy a Noon gift card in the UAE?",
    answer:
      "If a Noon gift card is available, you can view the available value and purchase details on its product page. Always check the applicable terms and redemption information before buying.",
  },
  {
    question: "Are gift cards available in AED?",
    answer:
      "Gift card denominations and pricing depend on the individual product. Where AED-denominated options are available, the relevant product page will show the applicable value and price.",
  },
  {
    question: "Can I send a gift card to someone in the UAE?",
    answer:
      "Digital gift cards can be suitable for sending as gifts, subject to the specific product's delivery method and terms. Check the individual product page for the available delivery information.",
  },
  {
    question: "What gift card should I buy for a gamer?",
    answer:
      "Gaming gift cards can be a suitable choice for gamers. Options may include brands and gaming platforms such as Roblox, Fortnite and other available gaming products. Always check the product's region, compatibility and redemption requirements before purchasing.",
  },
  {
    question: "Are gift cards refundable?",
    answer:
      "Refund and cancellation conditions depend on the specific product and applicable terms. Customers should review the product information and applicable terms before purchasing.",
  },
  {
    question:
      "How do I know whether a gift card is compatible with my account or region?",
    answer:
      "Check the individual product page for the applicable country, region, platform and redemption requirements before purchasing. Gift-card compatibility can vary by brand and product.",
  },
];

const FaqSection = () => {
  const [expanded, setExpanded] = useState(null);

  const handleChange = (index) => (_, isExpanded) => {
    setExpanded(isExpanded ? index : null);
  };

  return (
    <Box
      sx={{
        width: "100%",
        py: { xs: 3, sm: 4 },
        // backgroundColor: "#fff",
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          px: {
            xs: 1,
            sm: 2,
            md: 3,
          },
        }}
      >
        {/* Heading */}
        <Typography
          component="h2"
          sx={{
            fontSize: {
              xs: "21px",
              sm: "24px",
              md: "25px",
            },
            lineHeight: 1.3,
            fontWeight: 500,
            color: "#344054",
            mb: { xs: 2, sm: 2.5 },
          }}
        >
          Frequently Asked Questions About Gift Cards in UAE
        </Typography>

        {/* FAQ Grid */}
        <Grid
          container
          columnSpacing={{ xs: 0, md: 2 }}
          rowSpacing={{ xs: 1.5, md: 3 }}
        >
          {faqData.map((faq, index) => {
            const isOpen = expanded === index;

            return (
              <Grid item xs={12} md={6} key={faq.question}>
                <Accordion
                  expanded={isOpen}
                  onChange={handleChange(index)}
                  disableGutters
                  sx={{
                    width: "100%",
                    borderRadius: "28px !important",
                    backgroundColor: "#dff2f8",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.18)",
                    overflow: "hidden",
                    transition: "all 0.2s ease",

                    "&:before": {
                      display: "none",
                    },

                    "&:hover": {
                      backgroundColor: "#d9f0f6",
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      <Box
                        sx={{
                          width: 26,
                          height: 26,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#667085",
                          flexShrink: 0,
                        }}
                      >
                        {isOpen ? (
                          <RemoveIcon
                            sx={{
                              fontSize: 22,
                              fontWeight: 400,
                            }}
                          />
                        ) : (
                          <AddIcon
                            sx={{
                              fontSize: 22,
                              fontWeight: 400,
                            }}
                          />
                        )}
                      </Box>
                    }
                    aria-controls={`faq-${index}-content`}
                    id={`faq-${index}-header`}
                    sx={{
                      minHeight: {
                        xs: "58px !important",
                        sm: "60px !important",
                      },

                      px: {
                        xs: 2,
                        sm: 2.5,
                        md: 2.75,
                      },

                      py: 0,

                      "& .MuiAccordionSummary-content": {
                        margin: "0 !important",
                        alignItems: "center",
                      },

                      "& .MuiAccordionSummary-expandIconWrapper": {
                        marginLeft: 1,
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "14px",
                          sm: "15px",
                          md: "16px",
                        },
                        lineHeight: 1.35,
                        fontWeight: 500,
                        color: "#173b5f",
                        pr: 1,
                      }}
                    >
                      {faq.question}
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails
                    sx={{
                      px: {
                        xs: 2,
                        sm: 2.5,
                        md: 2.75,
                      },
                      pt: 0,
                      pb: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "13px",
                          sm: "14px",
                        },
                        lineHeight: 1.6,
                        color: "#52657a",
                      }}
                    >
                      {faq.answer}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
};

export default FaqSection;
